if (!customElements.get("td-cross-sell")) {
    class TDCrossSell extends HTMLElement {
        constructor() {
            super();
            this.BUTTON_CLASS = '.td-atc';
            this.COLOR_SWATCH_CLASS = '.product-form__color-swatch';
            this.RADIO_INPUT_CLASS = 'input[type="radio"]';
            this.PRICE_CLASS = '.td-cs-atc--price';
            this.COMPARE_CLASS = '.td-cs-atc--compare';
            this.SELECTED_COLOR_CLASS = '.td-cs-selected-color';

            this.mainButton = this.querySelector(this.BUTTON_CLASS);
            this.inputs = this.querySelectorAll(this.COLOR_SWATCH_CLASS);
            this.radioInputs = this.querySelectorAll(this.RADIO_INPUT_CLASS);
            this.priceEl = this.querySelector(this.PRICE_CLASS);
            this.compareEl = this.querySelector(this.COMPARE_CLASS);
            this.selectedColorEl = this.querySelector(this.SELECTED_COLOR_CLASS);
        }

        connectedCallback() {
            this.listenerController = new AbortController();
            const signal = this.listenerController.signal;
            if (this.mainButton && this.radioInputs.length > 0) {
                const checkedInput = Array.from(this.radioInputs).find((input) => input.checked);
                if (checkedInput) {
                    this.mainButton.dataset.productId = checkedInput.value;
                    this.updatePrice(checkedInput);
                }

                this.radioInputs.forEach((input) => {
                    input.addEventListener('change', () => {
                        this.mainButton.dataset.productId = input.value;
                        this.updatePrice(input);
                    }, { signal });
                });
            }

            if (this.inputs.length > 0) {
                this.inputs.forEach((input) => {
                    input.addEventListener('click', () => {
                        if (this.mainButton) {
                            this.mainButton.dataset.productId = input.dataset.id;
                        }
                    }, { signal });
                });
            }
        }

        disconnectedCallback() {
            this.listenerController.abort();
        }

        updatePrice(input) {
            // input.dataset.price / .compare are already money-formatted server-side
            // (Liquid `| money_with_currency`), so they can be written directly.
            if (this.priceEl && input.dataset.price) {
                this.priceEl.textContent = input.dataset.price;
            }

            if (this.selectedColorEl && input.dataset.colorValue) {
                this.selectedColorEl.textContent = input.dataset.colorValue;
            }

            if (this.compareEl) {
                if (input.dataset.compare) {
                    this.compareEl.textContent = input.dataset.compare;
                    this.compareEl.hidden = false;
                } else {
                    this.compareEl.textContent = '';
                    this.compareEl.hidden = true;
                }
            }
        }
    }

    customElements.define("td-cross-sell", TDCrossSell);
}
